import React from 'react';
import { push } from 'connected-react-router';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import AuthActions from '../../store/authRedux';
import HrbTranslate from '../language/HrbTranslate';
import SearchClients from '../search/SearchClients';

const Header = props => {

    const { userFirstName, signedIn, logoutUser, requestLogin } = props

    return (
        <div id='header' className='columns level'>
            <div className='column is-8 level-item'>
                {signedIn && <SearchClients />}
            </div>
            <div className='column is-2 level-item'>
                <div className='is-pulled-right'>
                    {signedIn && `${userFirstName}`}
                </div>
            </div>
            <div className='column is-2 level-item'>
                {signedIn && <a onClick={() => { logoutUser() }}><HrbTranslate text='Header.SignOut' /></a>}
                {!signedIn && <a onClick={() => { requestLogin() }}><HrbTranslate text='Header.SignIn' /></a>}
            </div>
        </div>
    );
}

Header.propTypes = {
    signedIn: PropTypes.bool,
    userFirstName: PropTypes.string,
    logoutUser: PropTypes.func,
    requestLogin: PropTypes.func,
    pushNavigation: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        signedIn: state.auth.signedIn,
        userFirstName: state.accountData.firstName
    }
}

const mapDispatchToProps = (dispatch) => ({
    logoutUser: () => dispatch(AuthActions.logoutUser()),
    requestLogin: () => dispatch(AuthActions.requestLogin()),
    pushNavigation: (path) => dispatch(push(path))
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)